import React, { useEffect, useState, useRef } from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import { Card, Tag } from 'antd';

const LearningProgressNCorrectCard = ({
                                          items,                // затронутые элементы из /practice/{id}/stats
                                          touched,              // сколько элементов вообще трогали
                                          practiceId,
                                          practiceType,
                                          practiceFormat,
                                          requiredCorrectAnswers,
                                          criterion,
                                          total,
                                          step = 30,         // горизонтальный промежуток между прямоугольниками
                                          rectWidth = 26,    // ширина прямоугольника
                                          rectHeight = 15,   // высота прямоугольника
                                          verticalGap = 4,   // вертикальный промежуток между строками
                                          rx = 3             // радиус скругления углов
                                      }) => {
    const containerRef = useRef(null);
    const [columns, setColumns] = useState(1);

    const isMobile = useIsMobile();

    // Затронутые элементы приходят с сервера, нетронутые достраиваются нулями: у них
    // нет документа прогресса, и отдавать их с сервера значило бы снова возвращать
    // ответ длиной с колоду.
    const answered = (items || [])
        .map(item => ({
            uuid: item.itemId,
            // Правило то же, что на сервере: при критерии «подряд» порог берёт серия, а
            // не сумма. Иначе элемент с пятью верными и оборванной серией показывался бы
            // выученным, хотя практика продолжает его показывать.
            status: criterion === 'CONSECUTIVE_CORRECT'
                ? (item.streak ?? 0) >= requiredCorrectAnswers
                : item.correctAnswerCount >= requiredCorrectAnswers
        }))
        .sort((a, b) => a.uuid.localeCompare(b.uuid));

    const untouched = Math.max(0, (total || 0) - (touched || answered.length));
    const processedData = answered.concat(
        Array.from({ length: untouched }, (unused, index) => ({
            uuid: `untouched-${index}`,
            status: false
        })));

    // Обновление числа колонок в зависимости от ширины контейнера
    useEffect(() => {
        const updateColumns = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth;
                const newColumns = Math.floor(containerWidth / step);
                setColumns(newColumns > 0 ? newColumns : 1);
            }
        };

        updateColumns();
        window.addEventListener("resize", updateColumns);
        return () => window.removeEventListener("resize", updateColumns);
    }, [step]);


    // Подсчёт процента выученных элементов (отмеченных зелёными)
    const learnedCount = processedData.filter(item => item.status).length;
    const learnedPercentage = processedData.length
        ? Math.round((learnedCount / processedData.length) * 100)
        : 0;

    // Расчёт количества строк (минимум одна)
    const rows = Math.max(Math.ceil(processedData.length / columns), 1);
    // Ширина SVG основана на числе колонок и шаге
    const svgWidth = columns * step;
    // Высота SVG рассчитывается на основе высоты прямоугольников и вертикальных промежутков
    const svgHeight = rows * rectHeight + (rows - 1) * verticalGap;

    // Стили для заголовка карточки
    const headerStyle = {
        fontSize: '18px',
        color: '#02796b',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    };


    return (
        <Card
            type="inner"
            styles={{
                header: { backgroundColor: '#e5f9f6' },
                body: {
                    padding: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                },
            }}
            title={<div style={headerStyle}>Learning Progress</div>}
            bordered={false}
        >
            {/* Равномерное распределение тегов с вертикальными разделителями */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>







                <div style={{ flex: 1, textAlign: 'center' }}>
                    <Tag
                        bordered={false}
                        color={'rgba(238,96,2,0.1)'}
                        style={{
                            color:  '#ee6002',
                            height: '22px',
                            lineHeight: '22px',
                            marginLeft: '8px'

                        }}
                    >
                        {practiceType}
                    </Tag>
                </div>

                <div style={{ width: '1px', backgroundColor: '#000000', height: '16px' }} />




                <div style={{ flex: 1, textAlign: 'center' }}>
                    <Tag
                        bordered={false}
                        color={'rgba(2,123,131,0.1)'}
                        style={{
                            color:  '#027b83',
                            height: '22px',
                            lineHeight: '22px',
                            marginLeft: '8px',
                        }}
                    >
                        {isMobile ? `Pass Lv: ${requiredCorrectAnswers}` : `Passing level: ${requiredCorrectAnswers}`}

                        {/*{`Passing level: ${requiredCorrectAnswers}`}*/}
                    </Tag>
                </div>
                <div style={{ width: '1px', backgroundColor: '#000000', height: '16px' }} />
                <div style={{ flex: 1, textAlign: 'center' }}>
                    <Tag bordered={false} color="#f0f0f0"


                         style={{
                             color: '#808080',
                             height: '22px',
                             lineHeight: '22px',
                             marginLeft: '8px'
                         }}


                    >
                        {isMobile ? `Done: ${learnedPercentage}%` : `Learned: ${learnedPercentage}%`}

                        {/*{`Learned: ${learnedPercentage}%`}*/}
                    </Tag>
                </div>
            </div>
            <div ref={containerRef}>
                <svg width="100%" height={svgHeight} viewBox={`0 0 ${svgWidth} ${svgHeight}`}>
                    {processedData.map((item, index) => {
                        const { uuid, status } = item;
                        const col = index % columns;
                        const row = Math.floor(index / columns);
                        // Расчёт позиции прямоугольника по фиксированному горизонтальному шагу
                        const x = col * step;
                        const y = row * (rectHeight + verticalGap);
                        const fillColor = status ? "#027b83" : "#b0b0b0";

                        return (
                            <g key={uuid}>
                                <rect
                                    x={x}
                                    y={y}
                                    width={rectWidth}
                                    height={rectHeight}
                                    rx={rx}
                                    style={{ fill: fillColor }}
                                    className="transition"
                                />
                                <text
                                    x={x + rectWidth / 2}
                                    y={y + rectHeight / 2}
                                    fill="white"
                                    fontSize="8"
                                    fontWeight="bold"
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                >
                                    {index + 1}
                                </text>
                            </g>
                        );
                    })}
                </svg>
            </div>
        </Card>
    );
};

export default LearningProgressNCorrectCard;
